import { EventAuth } from '@iwentsourcing/core/event-store/event-auth.js';

export interface JwtSession {
  resolveToken(): Promise<string>;
  resolveAuth(): Promise<EventAuth>;
}

export interface SessionManager {
  resolveToken(): Promise<string | undefined>;
  resolveAuth(): Promise<EventAuth | undefined>;
}

export function createSessionManager() {
  let session: JwtSession | null = null;
  // TODO add signal as parameter
  let controller = new AbortController();

  return {
    async resolveAuth(): Promise<EventAuth | undefined> {
      if (!session) {
        return undefined;
      }
      return session.resolveAuth();
    },
    async resolveToken(): Promise<string | undefined> {
      if (!session) {
        return undefined;
      }
      return session.resolveToken();
    },
    addSession(fn: (signal: AbortSignal) => JwtSession) {
      session = fn(controller.signal);
    },
    clearSession() {
      controller.abort();
      controller = new AbortController();
      session = null;
    },
  };
}
